/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var SearchBox = /** @class */ (function () {
        function SearchBox() {
            this.searchBox = document.getElementById('searchBox');
            this.searchToggle = document.getElementById('searchToggle');
            this.searchForm = this.searchBox ? this.searchBox.querySelector('form') : null;
            this.q = document.getElementById('q');
            this.hasClosing = true;
        }
        SearchBox.init = function () {
            new SearchBox().run();
        };
        SearchBox.prototype.run = function () {
            var _this = this;
            if (!this.searchBox || !this.searchToggle || !this.searchForm || !this.q) {
                return;
            }
            if (this.searchBox.classList.contains('toggle')) {
                this.initToggle();
            }
            if (this.searchBox.classList.contains('width')) {
                this.setWidth();
                window.addEventListener('resize', function (evt) {
                    _this.setWidth();
                });
            }
        };
        SearchBox.prototype.initToggle = function () {
            var _this = this;
            this.searchBox.addEventListener('click', function (evt) {
                evt.stopPropagation();
            });
            this.searchToggle.addEventListener('click', function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
                if (!document.body.classList.contains('search-open')) {
                    _this.open();
                }
                else {
                    _this.close();
                }
            });
            document.body.addEventListener('click', function () {
                if (document.body.classList.contains('search-open')) {
                    _this.close();
                }
            });
        };
        SearchBox.prototype.close = function () {
            if (!document.body.classList.contains('search-open')) {
                return;
            }
            document.body.classList.remove('search-open');
            var i = this.searchToggle.querySelector('i');
            if (i instanceof HTMLElement) {
                i.classList.remove('fa-times');
                i.classList.add('fa-search');
            }
            if (this.hasClosing) {
                document.body.classList.add('search-closing');
                setTimeout(function () {
                    document.body.classList.remove('search-closing');
                }, 400);
            }
        };
        SearchBox.prototype.open = function () {
            document.body.classList.add('search-open');
            if (this.q instanceof HTMLInputElement) {
                this.q.focus();
            }
            var i = this.searchBox.querySelector('i');
            if (i instanceof HTMLElement) {
                i.classList.remove('fa-search');
                i.classList.add('fa-times');
            }
        };
        SearchBox.prototype.setWidth = function () {
            var _this = this;
            if (!this.isLargeBody()) {
                return;
            }
            var breathingSpace = 10;
            var level1s = document.querySelectorAll('#mainmenu .level1');
            var width = 0;
            level1s.forEach(function (level1) {
                width += _this.getOffsetWidthWithMargin(level1);
            });
            this.q.setAttribute('style', "min-width: " + width + "px");
            this.searchForm.setAttribute('style', "width: " + (width + breathingSpace) + "px");
        };
        SearchBox.prototype.isLargeBody = function () {
            return this.getBodyWidth() + 15 >= 992;
        };
        SearchBox.prototype.getBodyWidth = function () {
            return document.body.offsetWidth;
        };
        SearchBox.prototype.getOffsetWidthWithMargin = function (elm) {
            var computedStyle = window.getComputedStyle(elm);
            var width = parseInt(elm.offsetWidth.toString());
            width += parseInt(computedStyle.marginLeft.toString());
            width += parseInt(computedStyle.marginRight.toString());
            return width;
        };
        return SearchBox;
    }());

    SearchBox.init();
    // document.addEventListener('click', function(e: MouseEvent) {
    //     const target = e.target;
    //     console.log(target);
    // }, false);

}());
typeof tsBuild === 'function' && tsBuild();})();
